<script setup>
// Pill-shaped chip shell. Solid by default; `dashed` renders the add-affordance
// variant (dashed border, subtle until focused). Inner content — a label, an
// editable input, or a dropdown trigger — is supplied by the consumer via slots.
defineProps({
  dashed: { type: Boolean, default: false },
  small: { type: Boolean, default: false },
});
</script>

<template>
  <span class="chip" :class="{ dashed, small }">
    <span v-if="$slots.icon" class="chip-icon">
      <slot name="icon" />
    </span>
    <slot />
    <span v-if="$slots.trailing" class="chip-trailing">
      <slot name="trailing" />
    </span>
  </span>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/pill";

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  max-width: 100%;
  padding: 0 4px 0 12px;
  background-color: c.$background-grey-light;
  border: 1px solid transparent;
  border-radius: 999px;
}

.chip.dashed {
  @include pill.dashed-pill;

  gap: 4px;
  padding: 0 12px;
}

.chip.small {
  gap: 4px;
  padding: 0 4px 0 8px;
}

.chip.small.dashed {
  padding: 0 8px;
}

.chip-icon {
  display: inline-flex;
  flex-shrink: 0;
  color: c.$text-subtle;
}

// Dashed (add) variant: icon follows the chip's own colour so it shifts to
// the accent colour on focus along with the border.
.chip.dashed .chip-icon {
  color: inherit;
}

.chip-trailing {
  display: inline-flex;
  flex-shrink: 0;
}
</style>
